export default __webpack_public_path__ + "static/media/HDTX_Buyback_Scrip_English 2025.43f990d9.pdf";